import { api } from '@/core/http/apiClient';

/** The signed-in user, as `User/getUserDetails` returns it. The header reads `imagePath` (the Angular model said `photo`). */
export interface ProfileInfo {
  id?: string;
  name?: string;
  email?: string;
  imagePath?: string | null;
  businessId?: string;
  themeColor?: string;
}

export const menuService = {
  getProfileInfo: () => api.get<ProfileInfo>('User/getUserDetails'),
};
